import { Injectable } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { GenericComponent } from "./generic-component";
declare var $: any;

@Injectable()
export class GenericFormComponent extends GenericComponent {

    _formGroup: UntypedFormGroup;
    isLoadingRequest = false;
    isLoadingPage = false;

    public response: any = {};

    constructor() {
        super();
    }

    validateStepInputData() {

        this._formGroup.markAllAsTouched();

        if (this._formGroup.invalid) return;
    }

    isValidFormGroupModal() {

        this._formGroup.markAllAsTouched();

        if (this._formGroup.invalid) return false;

        return true;
    }

    setDataError(err: any) {

        this.response = err;
        this.isLoadingRequest = false;
        this._formGroup.markAsUntouched();
        console.log(err);
    }

    setDataResponse(response = {}) {
        this.response = response;
        this.isLoadingRequest = false;
    }

    setValueFc(fc: UntypedFormControl, value: any, emitEvent: boolean = false) {
        fc.setValue(value, { emitEvent });
    }

    getValueFc(fc: UntypedFormControl) {
        return fc.valid ? fc.value : undefined;
    }

    trimValue(control: UntypedFormControl): void {
        control.setValue((control.value || '').trim());
    }
}
